import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter } from "lucide-react";
import { CATEGORY_OPTIONS } from "@/lib/api";

export const Footer = () => {
  return (
    <footer className="mt-24 border-t border-zinc-200 bg-white">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-10 px-4 py-16 md:grid-cols-4 md:px-8">
        <div className="col-span-2 md:col-span-1">
          <img src="/kk-logo.png" alt="KK Beauty & Fashion" className="h-12 w-auto max-w-full" />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-500">
            Where beauty is passion. Your everyday beauty and style essentials, all in one place — easy to choose, easy to shop.
          </p>
          <div className="mt-5 flex gap-4 text-zinc-500">
            <a href="#" aria-label="Instagram" className="hover:text-zinc-900"><Instagram size={18} /></a>
            <a href="#" aria-label="Facebook" className="hover:text-zinc-900"><Facebook size={18} /></a>
            <a href="#" aria-label="Twitter" className="hover:text-zinc-900"><Twitter size={18} /></a>
          </div>
        </div>

        <div>
          <p className="label-eyebrow">Shop</p>
          <ul className="mt-4 space-y-3 text-sm text-zinc-600">
            {CATEGORY_OPTIONS.map((c) => (
              <li key={c.slug}>
                <Link to={`/category/${c.slug}`} className="hover:text-kkaccent">{c.name}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="label-eyebrow">Policies</p>
          <ul className="mt-4 space-y-3 text-sm text-zinc-600">
            <li><Link to="/policy/terms" className="hover:text-kkaccent" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
            <li><Link to="/policy/privacy" className="hover:text-kkaccent" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/policy/refund" className="hover:text-kkaccent" data-testid="footer-refund">Refund Policy</Link></li>
          </ul>
        </div>

        <div>
          <p className="label-eyebrow">Company</p>
          <ul className="mt-4 space-y-3 text-sm text-zinc-600">
            <li><Link to="/shop" className="hover:text-kkaccent">All Products</Link></li>
            <li><Link to="/admin/login" className="hover:text-kkaccent" data-testid="footer-admin">Admin Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-200">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-6 text-xs text-zinc-400 md:flex-row md:px-8">
          <p>© {new Date().getFullYear()} KK Beauty &amp; Fashion. All rights reserved.</p>
          <p>Secure checkout · Visa · Mastercard · Apple Pay · Google Pay</p>
        </div>
      </div>
    </footer>
  );
};
